//en
export default {
    message: {
        hello: 'hello',
        name: 'name'
    }
}